import React, { useState } from 'react'
import { GiHamburgerMenu } from 'react-icons/gi'
import { FaAngleLeft } from 'react-icons/fa'
import './sideMenu.css'

import { useAuth } from '../../context/AuthContext'
import LogInInfo from './LogInInfo'
import logsUserService from '../../services/LogsUserActionService'
import { Link } from 'react-router-dom'

function CourseNav({ toggleMenu }) {

  const { idUser, token } = useAuth()

  return (
    <nav className='w-screen bg-light-purple text-white grow-0'>
      <ul className='m-0 p-0'>
        <li className='flex justify-between items-center'>
          <div className='flex items-center gap-4 py-3'>
            <button onClick={toggleMenu} className='pl-5'>
              <GiHamburgerMenu className='text-white' />
            </button>
            <img
              src='/images/icons/logo-novo-white.png'
              className='w-12 hidden sm:block'
            ></img>
          </div>
          <div className='flex items-center'>
            <Link
              to="/e-learning-hub"
              className='flex items-center text-white gap-2 pr-8 lg:pr-4'
              onClick={() => logsUserService(idUser, "Clic en volver a MOC", token)}
            >
              <FaAngleLeft className='text-white' />
              Volver a MOC
            </Link>
            <LogInInfo className='hidden lg:flex ' />
          </div>
        </li>
      </ul>
    </nav>
  )
}

export default CourseNav
